import React, { useEffect } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { FormGroup, Label } from 'reactstrap';
import { getClientEngagementList as onGetClientEngagementList } from 'store/actions';
import { useFormikContext } from 'formik'; 
import PropTypes from 'prop-types';

const ClientEngagementListSeller = ({ clientId, agentId, typeId, statusId, isDisabled = false }) => {
    const dispatch = useDispatch();
    const { values, errors, touched, setFieldValue, handleBlur } = useFormikContext();

    const { clientengagements } = useSelector(state => ({
        clientengagements: state.Clients.clientengagements,
    }));

    useEffect(() => {
        if (clientId && agentId) { 
            dispatch(onGetClientEngagementList(clientId, agentId, typeId, statusId));
        }
    }, [dispatch, clientId, agentId, typeId, statusId]);
   
    const getType = (type) => {
     
        if (type === 1) return 'Sell';
        if (type === 2) return 'Lease';
        return 'Unknown Type';
    };
    const formatYYMM = (dateStr) => {
        if (!dateStr) return "0000";
        const date = new Date(dateStr);
        const yy = String(date.getFullYear()).slice(2);
        const mm = String(date.getMonth() + 1).padStart(2, '0');
        return `${yy}${mm}`;
      };
    return (
        <FormGroup className="mb-3">
            <Label htmlFor="engagementId">Deal</Label>
            <select
                name="engagementId"
                className={`form-control ${errors.engagementId && touched.engagementId ? "is-invalid" : ""}`}
                onChange={(e) => setFieldValue("engagementId", e.target.value)}
                onBlur={handleBlur}
                value={values.engagementId}
                 disabled={isDisabled}
            >
                <option value="">Select</option>
                {clientengagements?.map(option => (
                    <option key={option.id} value={option.id}>
                        {option.contactName} - {getType(option.sellerType)} - ({option.id} - {formatYYMM(option.lastAgreementDate)})
                    </option>
                ))}
            </select>
            {errors.engagementId && touched.engagementId && (
                <div className="invalid-feedback">{errors.engagementId}</div>
            )}
        </FormGroup>
    );
};

ClientEngagementListSeller.propTypes = {
    clientId: PropTypes.string.isRequired,
    agentId: PropTypes.string.isRequired,
    typeId: PropTypes.number,
    statusId: PropTypes.number,
    isDisabled:PropTypes.bool
};

export default ClientEngagementListSeller;
